import { getApiUrl, getSocketUrl } from "@clockwise/client-commons/src/config/api";

export const GRAPHQL_URL = `${getApiUrl()}/graphql`;
export const GRAPHQL_BATCH_URL = `${GRAPHQL_URL}/batch`;
export const SUBSCRIPTION_URL = `${getSocketUrl()}/subscription`;
